module.exports = __webpack_public_path__ + "static/img/2_1_1.e519181b.jpg";